type AttrKeys = keyof typeof AUTH_ATTRIBUTES_CONSTANT;

export const AUTH_ATTRIBUTES_CONSTANT = {
  email: {
    type: 'email',
    key: 'email',
    label: 'Email',
  },
  password: {
    type: 'password',
    key: 'password',
    label: 'Password',
  },
  verification_code: {
    type: 'number',
    key: 'verification_code',
    label: 'Verification Code',
  },
  new_password: {
    type: 'password',
    key: 'new_password',
    label: 'New Password',
  },
  confirm_password: {
    type: 'password',
    key: 'confirm_password',
    label: 'Confirm Password',
  },
} as const;

export const AUTH_MESSAGE_CONSTANT = {
  [AUTH_ATTRIBUTES_CONSTANT.email.key as AttrKeys]: {
    pattern: 'Please enter a valid email',
    confirmPasswordValidator: '',
  },
};
